import GeneralFilter from "../GeneralFilter";

function EnquiryFilter() {
  return <GeneralFilter />;
}

export default EnquiryFilter;
